/* Guided compositions share the expert's physical 12 cm size reference.
   Layout changes only positions and editable text: artwork.svg is never rewritten. */
(function(root){'use strict';
const layouts={
 signature:{font:'allura',curve:0,titleY:.81,size:6.4,examples:{caption:'Notre histoire',subtitle:'Porquerolles · été 2026'}},
 editorial:{font:'allura',curve:0,titleY:.14,size:6.4,examples:{caption:'Un instant à nous',subtitle:'20 juin 2026'}},
 none:{font:'allura',curve:0,size:6.4,examples:{caption:'',subtitle:''}}
};
const fonts={allura:'Photo Allura',cormorant:'Photo Cormorant',dmsans:'Photo DM Sans'};
function normalizeLayout(layout){return layout==='arc'?'editorial':Object.hasOwn(layouts,layout)?layout:'signature';}
/* Only suggestions are replaceable. The optional exampleFields flags let the
   form explicitly protect a field that a visitor has edited, even when it
   happens to equal one of our examples. Empty fields receive the new example.
   Nothing is erased when the lettering is temporarily hidden. */
function selectLayout(options,nextLayout){
 const current=options||{},previous=normalizeLayout(current.layout),next=normalizeLayout(nextLayout),out={...current,layout:next};
 if(next==='none')return out;
 out.font=layouts[next].font;
 out.exampleFields={...current.exampleFields};
 for(const key of ['caption','subtitle']){
  const value=typeof current[key]==='string'?current[key]:'',trimmed=value.trim();
  const wasExample=current.exampleFields?.[key]===false?false:
   previous==='none'?Object.values(layouts).some(p=>p.examples[key]&&p.examples[key]===trimmed):layouts[previous].examples[key]===trimmed;
  if(!trimmed||wasExample){out[key]=layouts[next].examples[key];out.exampleFields[key]=true;}
  else out.exampleFields[key]=false;
 }
 return out;
}
function arcLayout(widths,fs,curve){
 const total=widths.reduce((a,b)=>a+b,0),aw=Math.max(total*1.12,fs*3),cv=curve/100,d=cv>0?1:-1,sag=Math.abs(cv)*aw*.42;
 const bez=t=>({x:aw*(t-.5),y:-4*d*sag*t*(1-t)}),N=160,acc=[0];let prev=bez(0);
 for(let k=1;k<=N;k++){const p=bez(k/N);acc.push(acc[k-1]+Math.hypot(p.x-prev.x,p.y-prev.y));prev=p;}
 const len=acc[N];let run=(len-total)/2;
 return widths.map(w=>{const l=Math.max(0,Math.min(len,run+w/2));let t=1;for(let q=1;q<=N;q++){if(acc[q]>=l){t=(q-1+(acc[q]>acc[q-1]?(l-acc[q-1])/(acc[q]-acc[q-1]):0))/N;break;}}run+=w;return {...bez(t),a:Math.atan2(-4*d*sag*(1-2*t),aw)};});
}
function compose(o,art,measure){
 const layout=normalizeLayout(o.layout),preset=layouts[layout],shape=o.shape==='carree'?'carree':'hexa',W=shape==='hexa'?120:130,H=shape==='hexa'?100:130;
 // The photo-only layout must ignore retained form values as well as hide
 // their lettering: neither optional line is allowed to reserve empty space.
 const caption=layout==='none'?'':(o.caption||'').trim(),subtitle=layout==='none'?'':(o.subtitle||'').trim(),font=fonts[o.font]?o.font:preset.font;
 // Photo artwork may reach the physical edge. Lettering retains its own
 // 3 mm breathing room: enlarging the photograph must not clip a caption.
 const artMargin=0,textMargin=3,gap=2;
 function halfWidth(y,inset=artMargin){return shape==='hexa'? W*(.5-.5*Math.abs(y/H-.5))-inset*Math.hypot(1,W/(2*H)) : W/2-inset;}
 function textWidth(text,id,fs,curve){return measure?measure(text,id,fs,!!curve):text.length*fs*.53;}
 function glyphBounds(text,id,fs){
  const b=measure&&typeof measure.bounds==='function'?measure.bounds(text,id,fs):null;
  if(b&&['left','right','top','bottom'].every(k=>Number.isFinite(b[k])))return b;
  return {left:textWidth(text,id,fs,false)/2,right:textWidth(text,id,fs,false)/2,top:fs*.8,bottom:fs*.8};
 }
 function textGeometry(text,id,fs,curve){
  let points=[];
  function corners(b,x,y,a){
   const ca=Math.cos(a),sa=Math.sin(a);
   for(const px of [-b.left,b.right])for(const py of [-b.top,b.bottom])points.push({x:x+px*ca-py*sa,y:y+px*sa+py*ca});
  }
  if(curve){
   const chars=text.split(''),widths=chars.map(c=>textWidth(c,id,fs,true)),pos=arcLayout(widths,fs,curve);
   chars.forEach((c,i)=>corners(glyphBounds(c,id,fs),pos[i].x,pos[i].y,pos[i].a));
  }else corners(glyphBounds(text,id,fs),0,0,0);
  return {points,left:Math.min(...points.map(p=>p.x)),right:Math.max(...points.map(p=>p.x)),top:Math.min(...points.map(p=>p.y)),bottom:Math.max(...points.map(p=>p.y))};
 }
 function makeText(text,id,size,curve,edge,position){
  if(!text)return null;
  function at(fs){
   const g=textGeometry(text,id,fs,curve),y=position-(edge==='top'?g.top:g.bottom);
   return {fs,g,y,fits:g.points.every(p=>{const py=y+p.y;return py>=textMargin-1e-7&&py<=H-textMargin+1e-7&&Math.abs(p.x)<=halfWidth(py,textMargin)+1e-7;})};
  }
  let high=size*1.2,low=0,placed=at(high);
  if(!placed.fits){for(let n=0;n<26;n++){const mid=(low+high)/2,p=at(mid);if(p.fits)low=mid;else high=mid;}placed=at(low);}
  return {element:{type:'text',text,x:.5,y:placed.y/H,font:id,size:placed.fs/1.2,weight:400,ls:0,lh:1.2,align:'center',curve,color:'#4a2616'},top:placed.y+placed.g.top,bottom:placed.y+placed.g.bottom};
 }
 // A suspension hole never moves or resizes the photo: framing is owned by the user.
 let detail,title,topLimit=artMargin,bottomLimit=H-artMargin;
 const titleSize=preset.size*Math.max(.8,Math.min(1.25,Number(o.textScale||100)/100));
 if(layout==='editorial'){
  // The editorial composition is one coherent text block above the photo.
  // Keep its secondary line quiet and leave the whole lower band to the art.
  title=makeText(caption,font,titleSize,preset.curve,'top',textMargin);
  const detailSize=title?Math.min(2.7,title.element.size*.72):2.7;
  detail=makeText(subtitle,'dmsans',detailSize,0,'top',title?title.bottom+1.5:textMargin);
  topLimit=detail?detail.bottom+gap:title?title.bottom+gap:artMargin;
 }else{
  // Signature keeps its established two-line arrangement below the drawing.
  detail=makeText(subtitle,'dmsans',2.7,0,'bottom',H-textMargin);
  title=makeText(caption,font,titleSize,preset.curve,'bottom',detail?detail.top-gap:H-textMargin);
  bottomLimit=title?title.top-gap:detail?detail.top-gap:H-artMargin;
 }
 // Reserve only measured ink plus 2 mm breathing room. Empty optional texts
 // reserve nothing. Arc measurements include each rotated glyph's corners.
 const top=topLimit/H;
 const bottom=bottomLimit/H;
 const boxH=(bottom-top)*H,boxW=W-2*artMargin,view=art.viewBox||[0,0,1,1],aspect=view[2]/view[3];
 const zoom=Math.max(.6,Math.min(2.5,Number(o.zoom||100)/100)),shift=Number(o.shift||0)*H/100;
 // The hexagon is widest at its own centre. Centring in the remaining text
 // band could push a portrait toward a narrow corner and needlessly shrink it.
 const preferredCentre=shape==='hexa'?H/2:(top+bottom)*H/2;
 const centre=h=>Math.max(top*H+h/2,Math.min(bottom*H-h/2,preferredCentre));
 let low=0,high=Math.min(boxH,boxW/aspect);
 // Solve the largest safe rectangle, rather than shrinking once against the
 // narrower corners of a rectangle which is itself too tall.
 for(let n=0;n<28;n++){const h=(low+high)/2,y=centre(h);if(h*aspect/2<=Math.min(halfWidth(y-h/2),halfWidth(y+h/2)))low=h;else high=h;}
 let h=low*zoom,w=h*aspect,centreY=centre(low)+shift;
 const elements=[{type:'logo',logo:'custom_photo',x:.5+Math.max(-.4,Math.min(.4,Number(o.shiftX||0)/100)),y:centreY/H,size:Math.max(w,h)/1.2,svg:art.svg,color:'#4a2616'}];
 if(title)elements.push(title.element);
 if(detail)elements.push(detail.element);
 return {v:1,shape,hole:!!o.hole,allowShapes:['hexa','carree'],allowPlein:true,allowPerce:true,elements};
}
const api={compose,layouts,fonts,arcLayout,selectLayout,normalizeLayout};if(typeof module==='object'&&module.exports)module.exports=api;else root.PhotoComposition=api;
})(typeof window==='object'?window:this);
